<template>
  <div class="select-operator-main" ref="refSelectOperator">
    <div class="select-operator-inner">
      <div class="selected-display" :class="{ active: isOpenOption }" @click="isOpenOption = !isOpenOption" :id="idOperator">
        <div class="d-flex">
          <div v-if="!selectedValue" class="w-100 text-selected pe-3">{{ placeholder }}</div>
          <div v-else class="w-100 text-selected pe-3">{{ selectedValue }}</div>
          <div class="btn-open-option">
            <arrow-box-option-icon fill="#484848" class="arrow-box-option-icon" />
          </div>
        </div>
      </div>
      <div v-if="isOpenOption" class="option-display" :class="{ active: isOpenOption }">
        <div v-if="optionList" class="option-display-inner">
          <div class="item-list" @click="selectedItemOperator(optionListNone)">None</div>
          <div
            class="item-list"
            v-for="(item, index) in optionList"
            :key="index"
            @click="selectedItemOperator(item)"
            :class="{ selected: item[label] == selectedValue }"
          >
            {{ item[label] }}
          </div>
        </div>
        <div v-else class="option-display-inner empty">
          <div class="item-list text-center">{{ t('component.filter_table.components.select_operator.empty') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import ArrowBoxOptionIcon from '@/assets/icons/base/table/ArrowBoxOptionIcon.vue';

import useSelectOperator from '../hooks/useSelectOperator';

interface Props {
  label: string;
  options: any;
  idOperator: string;
  selectValue: any;
  placeholder: string;
}

const props = defineProps<Props>();

defineEmits(['on-selected']);

const { t } = useI18n();
const { selectedValue, isOpenOption, refSelectOperator, optionList, optionListNone, selectedItemOperator } = useSelectOperator(props);
</script>

<style lang="scss" scoped>
@import '@/assets/styles/base/filter-table/select-operator.scss';
</style>
